/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Shepherd from "shepherd.js";

var site = require("../../site/_data/site");
var translate = require("../../site/_data/i18n");

// Get locale from URL
var pathArray = window.location.pathname.split("/");
var locale = pathArray[1];

/*------------------------------------*\
    FEEDBACK TOUR
\*------------------------------------*/
class FeedbackTourProgress {
	constructor(passedElement) {
		let self = this;
		self.elem = passedElement;
	}

	/*-------------------------------------------------*\
        INIT
    \*-------------------------------------------------*/
	init() {
		let self = this;

		if (window.innerWidth < 1100) return;

		var shepherd = new Shepherd.Tour({
			defaultStepOptions: {
				classes: "tour-section",
				scrollTo: {
					behavior: "smooth",
					block: "center",
				},
			},
			steps: [
				{
					title: translate.feedback.feedbackProgress.viewYourProgress
						.title[locale],
					text: translate.feedback.feedbackProgress.viewYourProgress
						.description[locale],
					attachTo: {
						element:
							window.innerWidth > 400
								? ".js-feedback-tour-progress"
								: null,
						on: "left",
					},
					buttons: [
						{
							action: function () {
								return this.next();
							},
							text: translate.feedback.feedbackProgress
								.viewYourProgress.close[locale],
						},
					],
				},
			],
			useModalOverlay: true,
		});

		// If consultation closed don't show
		if (site.consultation.feedback_active == true) {
			// Don't show this on review/form pages
			let url = window.location.href;
			if (!url.includes(["feedback-form"])) {
				// Check if tour popup has already been dismissed
				if (localStorage.getItem("tour-progress-seen")) {
					console.log("%c" + "Tour progress seen", "color: green");
				} else if (localStorage.getItem("tour-question-seen")) {
					// Check if any feedback has been left before presenting tour popup
					let keys = Object.keys(localStorage),
						i = 0,
						key;

					for (; (key = keys[i]); i++) {
						if (key.includes("section")) {
							localStorage.setItem("tour-progress-seen", true);

							shepherd.start();
						}
					}
				}
			}
		}
	}
}

export default FeedbackTourProgress;
